import {BaseConfig} from "../../infrastructure/config/base-config";
import {RelatedEntitiesWidgetTerms} from "./related-entities-widget.terms";

export class RelatedEntitiesWidgetConfig extends BaseConfig {

  static injectables = [RelatedEntitiesWidgetTerms];

  constructor(terms: RelatedEntitiesWidgetTerms) {
    super('relatedEntitiesWidget', null, terms);
  }
}
